import { noop } from 'lodash/fp';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { deleteProject, hideModal, alertSuccess } from '../../redux/actions';
import text from '../../text';
import { Button } from '../button';
import Icon from '../icon/Icon';
export var DELETE_PROJECT_MODAL = 'DELETE_PROJECT_MODAL';
var DeleteProjectModal = function(param) {
    var show = param.show, projectId = param.projectId, name = param.name, _param_onSuccess = param.onSuccess, onSuccess = _param_onSuccess === void 0 ? noop : _param_onSuccess;
    var dispatch = useDispatch();
    var projectName = name !== null && name !== void 0 ? name : text('untitled');
    var onHide = function() {
        return dispatch(hideModal(DELETE_PROJECT_MODAL));
    };
    var onOk = function() {
        dispatch(deleteProject(projectId));
        dispatch(alertSuccess(text('deleteProjectSuccess', {
            projectName: projectName
        }), {
            icon: 'trash',
            dismissible: true
        }));
        onHide();
        onSuccess();
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        show: show,
        onHide: onHide
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered",
        closeButton: true
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "circled-exclamation"
    })), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "text-center"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "mb-3"
    }, text('areYouSureDeleteProject', {
        projectName: projectName
    })), /*#__PURE__*/ React.createElement("div", null, text('deleteWarningMessage'))), /*#__PURE__*/ React.createElement(Modal.Footer, null, /*#__PURE__*/ React.createElement(Button, {
        className: "full-width",
        variant: "outline-primary",
        onClick: onHide
    }, text('cancel')), /*#__PURE__*/ React.createElement(Button, {
        className: "full-width",
        onClick: onOk,
        autoFocus: true
    }, text('confirmDeleteProject'))));
};
export default DeleteProjectModal;
